import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
};
export function Button({
  children,
  href,
  className = '',
  fullWidth
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} className={`inline-flex items-center justify-center rounded-xl bg-primary px-7 py-4 font-display text-base font-bold text-white shadow-[0_10px_25px_rgba(7,59,92,.25)] transition-colors hover:bg-primary-dark focus:outline-none focus:ring-4 focus:ring-teal/30 ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-345" data-mp="ztashz69zs6f">
      {children}
    </motion.a>;
}